<template>
  <div class="revenue-tax-container">
    <div class="tab-header">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'operatingRevenue' }"
        @click="activeTab = 'operatingRevenue'"
      >
        营业收入及税金
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'profit' }"
        @click="activeTab = 'profit'"
      >
        利润
      </button>
    </div>

    <div class="tab-content">
      <OperatingRevenue
        v-if="activeTab === 'operatingRevenue'"
        ref="operatingRevenueRef"
        @save="handleSave"
      />
      <ProfitModule
        v-if="activeTab === 'profit'"
        ref="profitModuleRef"
        @save="handleSave"
      />
    </div>
  </div>
</template>

<script>
import OperatingRevenue from "./OperatingRevenue.vue";
import ProfitModule from "./ProfitModule.vue";

export default {
  name: "RevenueTax",
  components: {
    OperatingRevenue,
    ProfitModule,
  },
  data() {
    return {
      activeTab: "operatingRevenue",
    };
  },
  methods: {
    handleSave(componentData) {
      this.saveToVuex();
      this.$toast.success("保存成功");
    },
    saveToVuex() {
      const currentData = this.$store.state.projectData || {};
      const existingInvestmentEstimate = currentData.investmentEstimate || {};
      const existingRevenueTaxData =
        existingInvestmentEstimate.revenueTaxData || {};

      const newRevenueTaxData = {
        ...existingRevenueTaxData,
        operatingRevenueData:
          this.$refs.operatingRevenueRef?.getFormData() || {},
        profitModuleData: this.$refs.profitModuleRef?.getFormData() || {},
      };

      const newInvestmentEstimate = {
        ...existingInvestmentEstimate,
        revenueTaxData: newRevenueTaxData,
      };

      this.$store.commit("setProjectData", {
        ...currentData,
        investmentEstimate: newInvestmentEstimate,
      });
      this.$store.commit("setIsProjectSaved", false);
    },
  },
};
</script>

<style scoped>
.revenue-tax-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tab-header {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #409eff;
}

.tab-btn {
  padding: 10px 24px;
  border: none;
  background-color: #f5f7fa;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px 4px 0 0;
  margin-right: 2px;
}

.tab-btn:hover {
  color: #409eff;
  background-color: #ecf5ff;
}

.tab-btn.active {
  background-color: #409eff;
  color: #fff;
}

.tab-content {
  flex: 1;
  overflow: auto;
}
</style>
